import dashboardApi from 'services/api/dashboard'

import {
  SEND_PUSH_SUBSCRIPTION_FAILED,
  SEND_PUSH_SUBSCRIPTION_STARTED,
  SEND_PUSH_SUBSCRIPTION_SUCCESS
} from './actionTypes'

export const sendPushSubcription = subscription => {
  return async (dispatch, getState) => {
    dispatch({
      type: SEND_PUSH_SUBSCRIPTION_STARTED,
      payload: subscription
    })

    const {
      endpoint,
      keys: { p256dh: key1, auth: key2 }
    } = subscription

    const {
      login: { geolocation }
    } = getState()

    const model = {
      endpoint,
      key1,
      key2,
      isRemoved: false,
      ...geolocation
    }

    try {
      const response = await dashboardApi.sendPushSubscription(model)

      localStorage.setItem('pushConnected', JSON.stringify(response))

      dispatch({
        type: SEND_PUSH_SUBSCRIPTION_SUCCESS,
        payload: subscription
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: SEND_PUSH_SUBSCRIPTION_FAILED,
        payload: err
      })
    }
  }
}
